/* eslint-disable max-len */
import {inputType} from '../../../../../pages/esgManager/interface/inputType';

export const pillers = {
  autoMobileGovernance: 'pillar_governance',
  autoMobileStrategy: 'pillar_strategy',
  autoMobileRiskManagement: 'pillar_risk_management',
  autoMobileMetricsTargets: 'pillar_metrics_targets'
};

const AUTO_MOBILE_FIELD_NAMES = {
  AUTO_QG1_Q1_VALUE: 'autoQg1Q1_value',
  AUTO_QG1_Q1_COMMENT: 'autoQg1Q1_comment',
  AUTO_QG1_Q2_VALUE: 'autoQg1Q2_value',
  AUTO_QG1_Q2_COMMENT: 'autoQg1Q2_comment',
  AUTO_QG1_Q3_VALUE: 'autoQg1Q3_value',
  AUTO_QG1_Q3_COMMENT: 'autoQg1Q3_comment',

  AUTO_QG2_Q1_VALUE: 'autoQg2Q1_value',
  AUTO_QG2_Q1_COMMENT: 'autoQg2Q1_comment',
  AUTO_QG2_Q2_VALUE: 'autoQg2Q2_value',
  AUTO_QG2_Q2_COMMENT: 'autoQg2Q2_comment',
  AUTO_QG2_Q3_VALUE: 'autoQg2Q3_value',
  AUTO_QG2_Q3_COMMENT: 'autoQg2Q3_comment',
  AUTO_QG2_Q4_VALUE: 'autoQg2Q4_value',
  AUTO_QG2_Q4_COMMENT: 'autoQg2Q4_comment',
  AUTO_QG2_Q5_VALUE: 'autoQg2Q5_value',
  AUTO_QG2_Q5_COMMENT: 'autoQg2Q5_comment',
  AUTO_QG2_Q6_VALUE: 'autoQg2Q6_value',
  AUTO_QG2_Q6_COMMENT: 'autoQg2Q6_comment',
  AUTO_QG2_Q7_VALUE: 'autoQg2Q7_value',
  AUTO_QG2_Q7_COMMENT: 'autoQg2Q7_comment',

  AUTO_QG3_Q1_VALUE: 'autoQg3Q1_value',
  AUTO_QG3_Q1_COMMENT: 'autoQg3Q1_comment',
  AUTO_QG3_Q2_VALUE: 'autoQg3Q2_value',
  AUTO_QG3_Q2_COMMENT: 'autoQg3Q2_comment',
  AUTO_QG3_Q3_VALUE: 'autoQg3Q3_value',
  AUTO_QG3_Q3_COMMENT: 'autoQg3Q3_comment',
  AUTO_QG3_Q4_VALUE: 'autoQg3Q4_value',
  AUTO_QG3_Q4_COMMENT: 'autoQg3Q4_comment',

  AUTO_QG4_Q1_VALUE: 'autoQg4Q1_value',
  AUTO_QG4_Q2_VALUE: 'autoQg4Q2_value',
  AUTO_QG4_Q3_VALUE: 'autoQg4Q3_value',
  AUTO_QG4_Q4_VALUE: 'autoQg4Q4_value',
  AUTO_QG4_Q5_VALUE: 'autoQg4Q5_value',
  AUTO_QG4_Q6_VALUE: 'autoQg4Q6_value',
  AUTO_QG4_Q7_VALUE: 'autoQg4Q7_value',

  AUTO_QG5_Q1_VALUE: 'autoQg5Q1_value',
  AUTO_QG5_Q1_COMMENT: 'autoQg5Q1_comment',
  AUTO_QG5_Q2_VALUE: 'autoQg5Q2_value',
  AUTO_QG5_Q2_COMMENT: 'autoQg5Q2_comment',
  AUTO_QG5_Q3_VALUE: 'autoQg5Q3_value',
  AUTO_QG5_Q3_COMMENT: 'autoQg5Q3_comment',
  AUTO_QG5_Q4_VALUE: 'autoQg5Q4_value',
  AUTO_QG5_Q5_VALUE: 'autoQg5Q5_value',
  AUTO_QG5_Q6_VALUE: 'autoQg5Q6_value',
  AUTO_QG5_Q7_VALUE: 'autoQg5Q7_value',
  AUTO_QG5_Q7_COMMENT: 'autoQg5Q7_comment',
  AUTO_QG5_Q8_VALUE: 'autoQg5Q8_value',
  AUTO_QG5_Q8_COMMENT: 'autoQg5Q8_comment',
  AUTO_QG5_Q9_VALUE: 'autoQg5Q9_value',
  AUTO_QG5_Q9_COMMENT: 'autoQg5Q9_comment',

  AUTO_QG6_Q1_VALUE: 'autoQg6Q1_value',
  AUTO_QG6_Q1_COMMENT: 'autoQg6Q1_comment',
  AUTO_QG6_Q2_VALUE: 'autoQg6Q2_value',
  AUTO_QG6_Q2_COMMENT: 'autoQg6Q2_comment',
  AUTO_QG6_Q3_VALUE: 'autoQg6Q3_value',

  AUTO_QG7_Q1_VALUE: 'autoQg7Q1_value',
  AUTO_QG7_Q1_COMMENT: 'autoQg7Q1_comment',
  AUTO_QG7_Q2_VALUE: 'autoQg7Q2_value',
  AUTO_QG7_Q2_COMMENT: 'autoQg7Q2_comment',
  AUTO_QG7_Q3_VALUE: 'autoQg7Q3_value',
  AUTO_QG7_Q3_COMMENT: 'autoQg7Q3_comment',
  AUTO_QG7_Q4_VALUE: 'autoQg7Q4_value',
  AUTO_QG7_Q4_COMMENT: 'autoQg7Q4_comment',
  AUTO_QG7_Q5_VALUE: 'autoQg7Q5_value',
  AUTO_QG7_Q5_COMMENT: 'autoQg7Q5_comment',
  AUTO_QG7_Q6_VALUE: 'autoQg7Q6_value',
  AUTO_QG7_Q6_COMMENT: 'autoQg7Q6_comment',

  AUTO_QG8_Q1_VALUE: 'autoQg8Q1_value',
  AUTO_QG8_Q1_COMMENT: 'autoQg8Q1_comment',
  AUTO_QG8_Q2_VALUE: 'autoQg8Q2_value',
  AUTO_QG8_Q2_COMMENT: 'autoQg8Q2_comment',
  AUTO_QG8_Q3_VALUE: 'autoQg8Q3_value',
  AUTO_QG8_Q3_COMMENT: 'autoQg8Q3_comment',
  AUTO_QG8_Q4_VALUE: 'autoQg8Q4_value',
  AUTO_QG8_Q4_COMMENT: 'autoQg8Q4_comment',
  AUTO_QG8_Q5_VALUE: 'autoQg8Q5_value',
  AUTO_QG8_Q5_COMMENT: 'autoQg8Q5_comment',
  AUTO_QG8_Q6_VALUE: 'autoQg8Q6_value',
  AUTO_QG8_Q6_COMMENT: 'autoQg8Q6_comment',
  AUTO_QG8_Q7_VALUE: 'autoQg8Q7_value',
  AUTO_QG8_Q7_COMMENT: 'autoQg8Q7_comment',

  AUTO_QG9_Q1_VALUE: 'autoQg9Q1_value',
  AUTO_QG9_Q1_COMMENT: 'autoQg9Q1_comment',
  AUTO_QG9_Q2_VALUE: 'autoQg9Q2_value',
  AUTO_QG9_Q2_COMMENT: 'autoQg9Q2_comment',
  AUTO_QG9_Q3_VALUE: 'autoQg9Q3_value',
  AUTO_QG9_Q3_COMMENT: 'autoQg9Q3_comment',
  AUTO_QG9_Q4_VALUE: 'autoQg9Q4_value',
  AUTO_QG9_Q4_COMMENT: 'autoQg9Q4_comment',
  AUTO_QG9_Q5_VALUE: 'autoQg9Q5_value',
  AUTO_QG9_Q5_COMMENT: 'autoQg9Q5_comment',

  AUTO_QG10_Q1_VALUE: 'autoQg10Q1_value',
  AUTO_QG10_Q1_Y1_VALUE: 'autoQg10Q1_Y1_value',
  AUTO_QG10_Q1_Y1_COMMENT: 'autoQg10Q1_Y1_comment',
  AUTO_QG10_Q1_Y2_VALUE: 'autoQg10Q1_Y2_value',
  AUTO_QG10_Q1_Y2_COMMENT: 'autoQg10Q1_Y2_comment',
  AUTO_QG10_Q1_Y3_VALUE: 'autoQg10Q1_Y3_value',
  AUTO_QG10_Q1_Y3_COMMENT: 'autoQg10Q1_Y3_comment',
  AUTO_QG10_Q1_Y4_VALUE: 'autoQg10Q1_Y4_value',
  AUTO_QG10_Q1_Y4_COMMENT: 'autoQg10Q1_Y4_comment',
  AUTO_QG10_Q1_COMMENT: 'autoQg10Q1_comment',
  AUTO_QG10_Q2_VALUE: 'autoQg10Q2_value',
  AUTO_QG10_Q2_COMMENT: 'autoQg10Q2_comment',
  AUTO_QG10_Q3_VALUE: 'autoQg10Q3_value',
  AUTO_QG10_Q3_COMMENT: 'autoQg10Q3_comment',
  AUTO_QG10_Q4_VALUE: 'autoQg10Q4_value',
  AUTO_QG10_Q4_COMMENT: 'autoQg10Q4_comment',

  AUTO_QG11_Q1_VALUE: 'autoQg11Q1_value',
  AUTO_QG11_Q1_COMMENT: 'autoQg11Q1_comment',
  AUTO_QG11_Q2_VALUE: 'autoQg11Q2_value',
  AUTO_QG11_Q2_COMMENT: 'autoQg11Q2_comment',
  AUTO_QG11_Q3_VALUE: 'autoQg11Q3_value',
  AUTO_QG11_Q3_COMMENT: 'autoQg11Q3_comment',
  AUTO_QG11_Q4_VALUE: 'autoQg11Q4_value',
  AUTO_QG11_Q4_COMMENT: 'autoQg11Q4_comment',
  AUTO_QG11_Q5_VALUE: 'autoQg11Q5_value',
  AUTO_QG11_Q5_COMMENT: 'autoQg11Q5_comment',
  AUTO_QG11_Q6_VALUE: 'autoQg11Q6_value',
  AUTO_QG11_Q6_COMMENT: 'autoQg11Q6_comment',
  AUTO_QG11_Q7_VALUE: 'autoQg11Q7_value',
  AUTO_QG11_Q7_COMMENT: 'autoQg11Q7_comment',
  AUTO_QG11_Q8_VALUE: 'autoQg11Q8_value',
  AUTO_QG11_Q8_COMMENT: 'autoQg11Q8_comment',
  AUTO_QG11_Q9_VALUE: 'autoQg11Q9_value',
  AUTO_QG11_Q9_COMMENT: 'autoQg11Q9_comment',
  AUTO_QG11_Q10_VALUE: 'autoQg11Q10_value',
  AUTO_QG11_Q10_COMMENT: 'autoQg11Q10_comment',
  AUTO_QG11_Q11_VALUE: 'autoQg11Q11_value',
  AUTO_QG11_Q11_COMMENT: 'autoQg11Q11_comment'
} as const;

const yesNoData = ['Yes', 'No'];

export const AutoMobileQuestions = {
  QUESTION_GROUP_1: {
    KEY: '1',
    NAME: '1. Board Oversight of Climate-Related Risks and Opportunities',
    QUESTIONS: {
      QUESTION_1: {
        fieldType: inputType.RADIOGROUP,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG1_Q1_VALUE,
        fieldLabel: '',
        Question:
          'Q1.1 Is the board actively guiding the shift from ICE to EV production?',
        tooltip: '',
        options: yesNoData
      },
      QUESTION_1_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG1_Q1_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_2: {
        fieldType: inputType.RADIOGROUP,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG1_Q2_VALUE,
        fieldLabel: '',
        Question:
          'Q1.2 Are transition risks from global GHG and ZEV regulations reviewed at board level?',
        tooltip: '',
        options: yesNoData
      },
      QUESTION_2_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG1_Q2_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_3: {
        fieldType: inputType.RADIOGROUP,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG1_Q3_VALUE,
        fieldLabel: '',
        Question:
          'Q1.3 Are climate-related risks and opportunities embedded in board-level decisions on capital investments, product strategy, and regulatory positioning?',
        tooltip: '',
        options: yesNoData
      },
      QUESTION_3_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG1_Q3_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      }
    }
  },

  QUESTION_GROUP_2: {
    KEY: '2',
    NAME: `2. Management's Role in 
    Climate-Related Risk Assessment `,
    QUESTIONS: {
      QUESTION_1_DISPLAY: {
        fieldType: inputType.DISPLAY,
        fieldName: '',
        fieldLabel: '',
        Question: 'Q2.1 Who in management is accountable for:',
        tooltip: ''
      },
      QUESTION_1: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG2_Q1_VALUE,
        fieldLabel: 'Emissions compliance',
        Question: '',
        tooltip: ''
      },
      QUESTION_1_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG2_Q1_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_2: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG2_Q2_VALUE,
        Question: '',
        fieldLabel: 'Climate-aligned strategy'
      },
      QUESTION_2_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG2_Q2_COMMENT,
        fieldLabel: 'Comment'
      },
      QUESTION_3: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG2_Q3_VALUE,
        fieldLabel: 'EV adoption or decarbonization roadmap',
        Question: '',
        tooltip: ''
      },
      QUESTION_3_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG2_Q3_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_4_DISPLAY: {
        fieldType: inputType.DISPLAY,
        fieldName: '',
        fieldLabel: '',
        Question: 'Q2.2 Are climate risks integrated into:',
        tooltip: ''
      },
      QUESTION_4: {
        fieldType: inputType.RADIOGROUP,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG2_Q4_VALUE,
        fieldLabel: '',
        Question: 'R&D governance and investment decisions',
        tooltip: '',
        options: yesNoData
      },
      QUESTION_4_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG2_Q4_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_5: {
        fieldType: inputType.RADIOGROUP,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG2_Q5_VALUE,
        fieldLabel: '',
        Question: 'Product development and fleet transition plans',
        tooltip: '',
        options: yesNoData
      },
      QUESTION_5_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG2_Q5_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_6: {
        fieldType: inputType.RADIOGROUP,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG2_Q6_VALUE,
        fieldLabel: '',
        Question: 'Marketing and customer engagement strategies',
        tooltip: '',
        options: yesNoData
      },
      QUESTION_6_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG2_Q6_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_7: {
        fieldType: inputType.RADIOGROUP,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG2_Q7_VALUE,
        fieldLabel: '',
        Question:
          'Q2.3 Is there a structure for scenario analysis and TCFD-aligned disclosures within the management process?',
        tooltip: '',
        options: yesNoData
      },
      QUESTION_7_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG2_Q7_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      }
    }
  },

  QUESTION_GROUP_3: {
    KEY: '3',
    NAME: '3. Identified Climate-Related Risks and Opportunities',
    QUESTIONS: {
      QUESTION_1: {
        fieldType: inputType.RADIOGROUP,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG3_Q1_VALUE,
        fieldLabel: '',
        Question:
          'Q3.1 Are global ICE phase-out targets and ZEV subsidy timelines tracked as:',
        tooltip: '',
        options: ['Policy risks', 'Transition opportunities']
      },
      QUESTION_1_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG3_Q1_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_2_DISPLAY: {
        fieldType: inputType.DISPLAY,
        fieldName: '',
        fieldLabel: '',
        Question: 'Q3.2 Are opportunities identified in:',
        tooltip: ''
      },
      QUESTION_2: {
        fieldType: inputType.RADIOGROUP,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG3_Q2_VALUE,
        fieldLabel: '',
        Question: 'EV battery innovation or circularity',
        tooltip: '',
        options: yesNoData
      },
      QUESTION_2_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG3_Q2_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_3: {
        fieldType: inputType.RADIOGROUP,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG3_Q3_VALUE,
        fieldLabel: '',
        Question: 'Hydrogen fuel cell vehicle markets',
        tooltip: '',
        options: yesNoData
      },
      QUESTION_3_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG3_Q3_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_4: {
        fieldType: inputType.RADIOGROUP,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG3_Q4_VALUE,
        fieldLabel: '',
        Question: 'Smart mobility or shared EV services',
        tooltip: '',
        options: yesNoData
      },
      QUESTION_4_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG3_Q4_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      }
    }
  },

  QUESTION_GROUP_4: {
    KEY: '4',
    NAME: '4. Impact on Business, Strategy, and Financial Planning',
    QUESTIONS: {
      QUESTION_1_DISPLAY: {
        fieldType: inputType.DISPLAY,
        fieldName: '',
        fieldLabel: '',
        Question: 'Q4.1 How do emission regulations affect:'
      },
      QUESTION_1: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG4_Q1_VALUE,
        fieldLabel: '',
        Question: 'Product development strategy'
      },
      QUESTION_2: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG4_Q2_VALUE,
        fieldLabel: '',
        Question: 'Technology partnerships'
      },
      QUESTION_3: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG4_Q3_VALUE,
        fieldLabel: '',
        Question: 'Capital budgeting'
      },
      QUESTION_4_DISPLAY: {
        fieldType: inputType.DISPLAY,
        fieldName: '',
        fieldLabel: '',
        Question: 'Q4.2 What is the estimated financial impact of:'
      },
      QUESTION_4: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG4_Q4_VALUE,
        fieldLabel: '',
        Question: 'ZEV adoption mandates'
      },
      QUESTION_5: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG4_Q5_VALUE,
        fieldLabel: '',
        Question: 'Low-emission zones'
      },
      QUESTION_6: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG4_Q6_VALUE,
        fieldLabel: '',
        Question: 'Fuel economy labeling and compliance'
      },
      QUESTION_7: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG4_Q7_VALUE,
        fieldLabel: '',
        Question:
          'Q4.3 How are business models adapting to consumer EV adoption trends and fuel transition risks?'
      }
    }
  },

  QUESTION_GROUP_5: {
    KEY: '5',
    NAME: '5. Resilience of Strategy (Scenario-Based)',
    QUESTIONS: {
      QUESTION_1_DISPLAY: {
        fieldType: inputType.DISPLAY,
        fieldName: '',
        fieldLabel: '',
        Question:
          'Q5.1 Are the following climate scenarios used for resilience testing?',
        tooltip: ''
      },
      QUESTION_1: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG5_Q1_VALUE,
        fieldLabel: 'IEA NZE 2050',
        Question: '',
        tooltip: ''
      },
      QUESTION_1_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG5_Q1_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_2: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG5_Q2_VALUE,
        fieldLabel: 'IPCC RCP2.6 or equivalent 1.5°C pathways',
        Question: '',
        tooltip: ''
      },
      QUESTION_2_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG5_Q2_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_3: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG5_Q3_VALUE,
        fieldLabel: 'Other',
        Question: '',
        tooltip: ''
      },
      QUESTION_3_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG5_Q3_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_4_DISPLAY: {
        fieldType: inputType.DISPLAY,
        fieldName: '',
        fieldLabel: '',
        Question: 'Q5.2 How resilient are your:',
        tooltip: ''
      },
      QUESTION_4: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG5_Q4_VALUE,
        fieldLabel: '',
        Question: 'Manufacturing supply chains?',
        tooltip: ''
      },
      QUESTION_5: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG5_Q5_VALUE,
        fieldLabel: '',
        Question: 'Battery raw-material access and pricing?',
        tooltip: ''
      },
      QUESTION_6: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG5_Q6_VALUE,
        fieldLabel: '',
        Question: 'Long-term EV profitability models?',
        tooltip: ''
      },
      QUESTION_7_DISPLAY: {
        fieldType: inputType.DISPLAY,
        fieldName: '',
        fieldLabel: '',
        Question: 'Q5.3 Are scenario assumptions disclosed and do they cover:',
        tooltip: ''
      },
      QUESTION_7: {
        fieldType: inputType.RADIOGROUP,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG5_Q7_VALUE,
        fieldLabel: '',
        Question: 'Energy input prices',
        tooltip: '',
        options: yesNoData
      },
      QUESTION_7_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG5_Q7_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_8: {
        fieldType: inputType.RADIOGROUP,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG5_Q8_VALUE,
        fieldLabel: '',
        Question: 'Regulatory costs',
        tooltip: '',
        options: yesNoData
      },
      QUESTION_8_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG5_Q8_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_9: {
        fieldType: inputType.RADIOGROUP,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG5_Q9_VALUE,
        fieldLabel: '',
        Question: 'Technology learning curves',
        tooltip: '',
        options: yesNoData
      },
      QUESTION_9_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG5_Q9_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      }
    }
  },

  QUESTION_GROUP_6: {
    KEY: '6',
    NAME: '6. Identification & Assessment of Climate Risks',
    QUESTIONS: {
      QUESTION_1_DISPLAY: {
        fieldType: inputType.DISPLAY,
        fieldName: '',
        fieldLabel: '',
        Question: 'Q6.1 Are product-specific risks tracked for:',
        tooltip: ''
      },
      QUESTION_1: {
        fieldType: inputType.RADIOGROUP,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG6_Q1_VALUE,
        fieldLabel: '',
        Question: 'Fuel economy regulation compliance',
        tooltip: '',
        options: yesNoData
      },
      QUESTION_1_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG6_Q1_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_2: {
        fieldType: inputType.RADIOGROUP,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG6_Q2_VALUE,
        fieldLabel: '',
        Question: 'ICE vehicle sales bans in key markets',
        tooltip: '',
        options: yesNoData
      },
      QUESTION_2_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG6_Q2_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_3: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG6_Q3_VALUE,
        fieldLabel: '',
        Question:
          'Q6.2 How is customer-demand risk (e.g., EV hesitation, range anxiety) factored into product development or pricing?',
        tooltip: ''
      }
    }
  },

  QUESTION_GROUP_7: {
    KEY: '7',
    NAME: '7. Managing Climate-Related Risks',
    QUESTIONS: {
      QUESTION_1_DISPLAY: {
        fieldType: inputType.DISPLAY,
        fieldName: '',
        fieldLabel: '',
        Question:
          'Q7.1 What mitigation strategies exist within your company for:',
        tooltip: ''
      },
      QUESTION_1: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG7_Q1_VALUE,
        fieldLabel: 'EV battery supply-chain security',
        Question: '',
        tooltip: ''
      },
      QUESTION_1_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG7_Q1_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_2: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG7_Q2_VALUE,
        fieldLabel: 'Grid readiness and charging infrastructure',
        Question: '',
        tooltip: ''
      },
      QUESTION_2_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG7_Q2_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_3: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG7_Q3_VALUE,
        fieldLabel: 'Other Mitigation Strategies',
        Question: '',
        tooltip: ''
      },
      QUESTION_3_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG7_Q3_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_4_DISPLAY: {
        fieldType: inputType.DISPLAY,
        fieldName: '',
        fieldLabel: '',
        Question: 'Q7.2 Are the following considered for resilience?',
        tooltip: ''
      },
      QUESTION_4: {
        fieldType: inputType.RADIOGROUP,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG7_Q4_VALUE,
        fieldLabel: '',
        Question: 'ICE platform retrofits',
        tooltip: '',
        options: yesNoData
      },
      QUESTION_4_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG7_Q4_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_5: {
        fieldType: inputType.RADIOGROUP,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG7_Q5_VALUE,
        fieldLabel: '',
        Question: 'Partnerships for fuel-cell or hybrid systems',
        tooltip: '',
        options: yesNoData
      },
      QUESTION_5_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG7_Q5_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_6: {
        fieldType: inputType.RADIOGROUP,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG7_Q6_VALUE,
        fieldLabel: '',
        Question:
          'Physical-risk protection (e.g., flooding in production hubs)',
        tooltip: '',
        options: yesNoData
      },
      QUESTION_6_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG7_Q6_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      }
    }
  },

  QUESTION_GROUP_8: {
    KEY: '8',
    NAME: '8. Integration into Risk Management',
    QUESTIONS: {
      QUESTION_1_DISPLAY: {
        fieldType: inputType.DISPLAY,
        fieldName: '',
        fieldLabel: '',
        Question: 'Q8.1 Are climate risks included in:',
        tooltip: ''
      },
      QUESTION_1: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG8_Q1_VALUE,
        fieldLabel: 'Enterprise Risk Management (ERM) systems',
        Question: '',
        tooltip: ''
      },
      QUESTION_1_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG8_Q1_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_2: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG8_Q2_VALUE,
        fieldLabel: 'Capital-investment decisions',
        Question: '',
        tooltip: ''
      },
      QUESTION_2_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG8_Q2_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_3: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG8_Q3_VALUE,
        fieldLabel: 'Warranty and residual-value modeling',
        Question: '',
        tooltip: ''
      },
      QUESTION_3_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG8_Q3_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_4: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG8_Q4_VALUE,
        fieldLabel: 'Other',
        Question: '',
        tooltip: ''
      },
      QUESTION_4_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG8_Q4_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_5_DISPLAY: {
        fieldType: inputType.DISPLAY,
        fieldName: '',
        fieldLabel: '',
        Question: 'Q8.2 Are climate risks linked to broader themes such as:',
        tooltip: ''
      },
      QUESTION_5: {
        fieldType: inputType.RADIOGROUP,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG8_Q5_VALUE,
        fieldLabel: '',
        Question: 'Supply-chain fragility',
        tooltip: '',
        options: yesNoData
      },
      QUESTION_5_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG8_Q5_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_6: {
        fieldType: inputType.RADIOGROUP,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG8_Q6_VALUE,
        fieldLabel: '',
        Question: 'Regulatory risk',
        tooltip: '',
        options: yesNoData
      },
      QUESTION_6_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG8_Q6_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_7: {
        fieldType: inputType.RADIOGROUP,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG8_Q7_VALUE,
        fieldLabel: '',
        Question: 'Shifts in customer demand or technological obsolescence',
        tooltip: '',
        options: yesNoData
      },
      QUESTION_7_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG8_Q7_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      }
    }
  },

  QUESTION_GROUP_9: {
    KEY: '9',
    NAME: '9. Metrics Used to Assess Risks and Opportunities',
    QUESTIONS: {
      QUESTION_1_DISPLAY: {
        fieldType: inputType.DISPLAY,
        fieldName: '',
        fieldLabel: '',
        Question:
          'Q9.1 What metrics are disclosed across the fleet? (Check all that apply)',
        tooltip: ''
      },
      QUESTION_1: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG9_Q1_VALUE,
        fieldLabel: 'gCO₂/km (fleet average)',
        Question: '',
        tooltip: ''
      },
      QUESTION_1_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG9_Q1_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_2: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG9_Q2_VALUE,
        fieldLabel: '% of EV/hybrid sales',
        Question: '',
        tooltip: ''
      },
      QUESTION_2_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG9_Q2_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_3: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG9_Q3_VALUE,
        fieldLabel: 'Battery lifecycle/ICE emissions & energy-density',
        Question: '',
        tooltip: ''
      },
      QUESTION_3_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG9_Q3_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_4: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG9_Q4_VALUE,
        fieldLabel: 'Other',
        Question: '',
        tooltip: ''
      },
      QUESTION_4_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG9_Q4_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_5: {
        fieldType: inputType.RADIOGROUP,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG9_Q5_VALUE,
        fieldLabel: '',
        Question:
          'Q9.2 Are Scope 3 avoided emissions from sold vehicles reported?',
        tooltip: '',
        options: yesNoData
      },
      QUESTION_5_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG9_Q5_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      }
    }
  },

  QUESTION_GROUP_10: {
    KEY: '10',
    NAME: '10. GHG Emissions Reporting',
    QUESTIONS: {
      QUESTION_1: {
        fieldType: inputType.GHG_EMISSIONS_REPORTING_10,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG10_Q1_VALUE,
        fieldLabel: '',
        Question: 'Q10.1 Are emissions reported across all scopes?',
        tooltip: '',
        options: yesNoData,
        fieldsListOnTriggerYes: [
          {
            fieldType: inputType.HEADING,
            fieldName: '',
            fieldLabel: 'Scope 1:',
            Question: '',
            tooltip: ''
          },
          {
            fieldType: inputType.CHECKBOX,
            fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG10_Q1_Y1_VALUE,
            fieldLabel: 'Fuel combustion from company-owned vehicles',
            Question: '',
            tooltip: ''
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG10_Q1_Y1_COMMENT,
            fieldLabel: 'Comment',
            Question: '',
            tooltip: ''
          },
          {
            fieldType: inputType.HEADING,
            fieldName: '',
            fieldLabel: 'Scope 2:',
            Question: '',
            tooltip: ''
          },
          {
            fieldType: inputType.CHECKBOX,
            fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG10_Q1_Y2_VALUE,
            fieldLabel: 'Electricity used in vehicle assembly and R&D',
            Question: '',
            tooltip: ''
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG10_Q1_Y2_COMMENT,
            fieldLabel: 'Comment',
            Question: '',
            tooltip: ''
          },
          {
            fieldType: inputType.HEADING,
            fieldName: '',
            fieldLabel: 'Scope 3:',
            Question: '',
            tooltip: ''
          },
          {
            fieldType: inputType.CHECKBOX,
            fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG10_Q1_Y3_VALUE,
            fieldLabel:
              'Upstream - metals, semiconductors, battery & other raw materials',
            Question: '',
            tooltip: ''
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG10_Q1_Y3_COMMENT,
            fieldLabel: 'Comment',
            Question: '',
            tooltip: ''
          },
          {
            fieldType: inputType.CHECKBOX,
            fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG10_Q1_Y4_VALUE,
            fieldLabel: 'Downstream - use-phase of sold vehicles',
            Question: '',
            tooltip: ''
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG10_Q1_Y4_COMMENT,
            fieldLabel: 'Comment',
            Question: '',
            tooltip: ''
          }
        ],
        fieldsOnTriggerNo: {
          fieldType: inputType.TEXTAREA,
          fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG10_Q1_COMMENT,
          fieldLabel: 'Comment'
        }
      },
      QUESTION_2_DISPLAY: {
        fieldType: inputType.DISPLAY,
        fieldName: '',
        fieldLabel: '',
        Question: 'Q10.2 Are GHG protocols aligned with:',
        tooltip: ''
      },
      QUESTION_2: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG10_Q2_VALUE,
        fieldLabel: 'GHG Protocol Corporate Standard',
        Question: '',
        tooltip: ''
      },
      QUESTION_2_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG10_Q2_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_3: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG10_Q3_VALUE,
        fieldLabel: 'Sectoral frameworks (e.g., ICCT, GLEC, IEA auto pathways)',
        Question: '',
        tooltip: ''
      },
      QUESTION_3_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG10_Q3_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_4: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG10_Q4_VALUE,
        fieldLabel: 'Other',
        Question: '',
        tooltip: ''
      },
      QUESTION_4_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG10_Q4_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      }
    }
  },

  QUESTION_GROUP_11: {
    KEY: '11',
    NAME: '11. Targets and Performance',
    QUESTIONS: {
      QUESTION_1_DISPLAY: {
        fieldType: inputType.DISPLAY,
        fieldName: '',
        fieldLabel: '',
        Question:
          'Q11.1 What targets are set by your company? (Check all that apply)',
        tooltip: ''
      },
      QUESTION_1: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG11_Q1_VALUE,
        fieldLabel: 'Absolute GHG-reduction targets',
        Question: '',
        tooltip: ''
      },
      QUESTION_1_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG11_Q1_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_2: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG11_Q2_VALUE,
        fieldLabel: 'Intensity-based targets (per km or vehicle unit)',
        Question: '',
        tooltip: ''
      },
      QUESTION_2_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG11_Q2_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_3: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG11_Q3_VALUE,
        fieldLabel: 'EV or hydrogen-vehicle sales milestones',
        Question: '',
        tooltip: ''
      },
      QUESTION_3_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG11_Q3_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_4: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG11_Q4_VALUE,
        fieldLabel: 'Other',
        Question: '',
        tooltip: ''
      },
      QUESTION_4_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG11_Q4_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_5_DISPLAY: {
        fieldType: inputType.DISPLAY,
        fieldName: '',
        fieldLabel: '',
        Question: 'Q11.2 Are targets aligned with:',
        tooltip: ''
      },
      QUESTION_5: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG11_Q5_VALUE,
        fieldLabel: 'SBTi',
        Question: '',
        tooltip: ''
      },
      QUESTION_5_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG11_Q5_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_6: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG11_Q6_VALUE,
        fieldLabel: 'National or regional ZEV mandates',
        Question: '',
        tooltip: ''
      },
      QUESTION_6_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG11_Q6_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_7: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG11_Q7_VALUE,
        fieldLabel: 'Other',
        Question: '',
        tooltip: ''
      },
      QUESTION_7_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG11_Q7_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_8_DISPLAY: {
        fieldType: inputType.DISPLAY,
        fieldName: '',
        fieldLabel: '',
        Question: 'Q11.3 Is progress tracked through:',
        tooltip: ''
      },
      QUESTION_8: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG11_Q8_VALUE,
        fieldLabel: 'Milestone-based roadmaps',
        Question: '',
        tooltip: ''
      },
      QUESTION_8_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG11_Q8_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_9: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG11_Q9_VALUE,
        fieldLabel: 'Annual scorecards or ESG disclosures',
        Question: '',
        tooltip: '',
        options: [
          {
            label:
              'Technology-readiness index (e.g., battery recycling or reuse metrics)',
            value:
              'Technology-readiness index (e.g., battery recycling or reuse metrics)'
          },
          {label: 'Other', value: 'Other'}
        ]
      },
      QUESTION_9_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG11_Q9_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_10: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG11_Q10_VALUE,
        fieldLabel:
          'Technology-readiness index (e.g., battery recycling or reuse metrics)',
        Question: '',
        tooltip: ''
      },
      QUESTION_10_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG11_Q10_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_11: {
        fieldType: inputType.CHECKBOX,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG11_Q11_VALUE,
        fieldLabel: 'Other',
        Question: '',
        tooltip: ''
      },
      QUESTION_11_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: AUTO_MOBILE_FIELD_NAMES.AUTO_QG11_Q11_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      }
    }
  }
};
